
<template>
	<div class="wrapper">
		<!-- <md-chip  @click="setSelect" md-clickable class="chip" :class='{"md-accent selected-tag": is_selected_all}'>
			全て
			<span class="tag-count" :class='{"selected-tag-count": is_selected_all}'>{{ tabs_count }}</span>
		</md-chip> -->
		<!-- <md-chip
			@click="start_edit_tags"
			md-clickable
			class="chip"
			:class='{"md-accent selected-tag": is_editing_tags}'
			>
			<md-icon style="font-size: 18px !important">settings</md-icon>
		</md-chip> -->
		<transition-group name="flip">
			<Tag
				:body="subete_tag"
				:key="subete_tag.id"
			/>
			<Tag
				:body="edit_tag"
				:key="edit_tag.id"
			/>
			<Tag
				v-for="tag in tags"
				:body="tag"
				:key="tag.id"
			/>
		</transition-group>
	</div>
</template>
<script>
import Tag from './Tag.vue'
import firebase from 'firebase'

export default {
	name: 'TagsFilter',
	components: {
		Tag
	},
	data: () => ({
		enable_show_more: false,
	}),
	computed: {
		subete_tag() {
			return {
				id: 'all_tag',
				name: 'All',
				count: this.tabs_count
			}
		},
		edit_tag() {
			return {
				id: 'edit_tag',
				// name: 'Edit',
			}
		},
		tabs_count () {
			return this.$store.getters['tabs/current_filtered_tabs'].length
		},
		tags () {
			return this.$store.getters['tags/tags']
		},
		is_selected_all: function () {
			return this.$store.state.tags.selected === ''
		},
		is_editing_tags() {
			return this.$store.state.tags.is_editing_tags
		}
	},
	mounted () {
		this.start()
	},
	destroyed () {
		this.stop()
	},
	methods: {
		start () {
			this.$store.dispatch('tags/startListener')
		},
		stop () {
			this.$store.dispatch('tags/stopListener')
		},
		setSelect: function () {
			this.$store.dispatch('tags/set_selected', '')
		},
		start_edit_tags() {
			// this.is_editing_tags = !this.is_editing_tags
			this.$store.commit('tags/switch_is_editing_tags')
		}
	}
}
</script>
<style lang="scss" scoped>
.wrapper {
	padding: 14px 0px 0px 0px;
}

.flip {
  // 要素が移動するときのアニメーション設定（基本的にはtransitionにtransformを設定していればいい）
  &-move {
    transition: transform 0.5s;
  }

  // 要素が入るときのアニメーション
  &-enter {
    // アニメーションの初期設定（初期値とtransitionを設定する）
    &-active {
      opacity: 0;
      transform: translate3d(0, -30px, 0);
      transition: opacity 0.5s, transform 0.5s;
    }
    // アニメーション開始（目標のプロパティ値を設定する）
    &-to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  // 要素が消える時のアニメーション
  &-leave {
    // アニメーションの初期設定
    &-active {
      // 要素が消える場合はabsoluteにする（重要！）
      position: absolute;
      transition: opacity 0.5s, transform 0.5s;
    }
    // アニメーション開始
    &-to {
      opacity: 0;
      transform: translate3d(0, -30px, 0);
    }
  }
}

.chip {
	height: 28px;
	line-height: 28px;
	margin-bottom: 12px;
	margin-left: 4px;
}
.tag-count {
	font-size: 12px;
	margin-right: -8px;
	background: white;
	padding: 2px 6px;
	border-radius: 12px;
	color: rgba(0, 0, 0, 0.87);
}

</style>
